define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FAssetStatusDomain = void 0;
    class FAssetStatusDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: FAssetStatusDomain.PresentInUse, value: "Present - In Use" },
                    { key: FAssetStatusDomain.PresentNotInUse, value: "Present - Not In Use" },
                    { key: FAssetStatusDomain.NotPresent, value: "Not Present" },
                    { key: FAssetStatusDomain.Transferred, value: "Transferred" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[FAssetStatusDomain.PresentInUse] = 0;
                this.KeyIndex[FAssetStatusDomain.PresentNotInUse] = 1;
                this.KeyIndex[FAssetStatusDomain.NotPresent] = 2;
                this.KeyIndex[FAssetStatusDomain.Transferred] = 3;
                this.ValueIndex = {};
                this.ValueIndex["Present - In Use"] = 0;
                this.ValueIndex["Present - Not In Use"] = 1;
                this.ValueIndex["Not Present"] = 2;
                this.ValueIndex["Transferred"] = 3;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.FAssetStatusDomain = FAssetStatusDomain;
    Object.defineProperty(FAssetStatusDomain, "PresentInUse", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(FAssetStatusDomain, "PresentNotInUse", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(FAssetStatusDomain, "NotPresent", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(FAssetStatusDomain, "Transferred", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(FAssetStatusDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
